"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require("react-redux");

var _components = require("components");

var _ContainerVideo = require("./ContainerVideo.scss");

var _ContainerVideo2 = _interopRequireDefault(_ContainerVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContainerVideo = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    isMobile: state.mobile.isMobile,
    isTablet: state.mobile.isTablet,
    isApple: state.mobile.isApple
  };
}, {}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ContainerVideo, _React$Component);

  function ContainerVideo(props, context) {
    (0, _classCallCheck3.default)(this, ContainerVideo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ContainerVideo.__proto__ || (0, _getPrototypeOf2.default)(ContainerVideo)).call(this, props, context));

    _this.videoInitialize = false;

    _this.containerVideo = _react2.default.createRef();
    _this.comLabVideo = _react2.default.createRef();
    _this.videoPlayerRef = _react2.default.createRef();
    _this.mute = _this.mute.bind(_this);
    _this.visibleInSlider = _this.visibleInSlider.bind(_this);
    _this.noVisibleInSlider = _this.noVisibleInSlider.bind(_this);
    _this.anioActive = _this.anioActive.bind(_this);

    // NOTA: Se ejecuta al dar click en el cover:
    _this.handleButtonPlay = _this.handleButtonPlay.bind(_this);
    _this.handleEndVideo = _this.handleEndVideo.bind(_this);
    _this.handleReadyVideo = _this.handleReadyVideo.bind(_this);
    _this.showModal = _this.showModal.bind(_this);
    _this.maskVideo = _this.maskVideo.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ContainerVideo, [{
    key: "handleButtonPlay",
    value: function handleButtonPlay() {
      if (this.props.isApple) {
        // this.mute(false);
        $('video').prop('muted', true);
        $('.containerVideo--active').removeClass('containerVideo--active');

        this.containerVideo.current.classList.add("containerVideo--active");

        this.videoPlayerRef.launchMuted(false);
        this.videoPlayerRef.launchPlay();
      } else {
        this.props.handleCarouselChangeYear(this.props.strings.anio); //indica cual es el año activado
        this.videoPlayerRef.launchPlay();
      }
    }
  }, {
    key: "handleReadyVideo",
    value: function handleReadyVideo() {
      var _this2 = this;

      // console.log("handleReadyVideo lanzado");
      this.videoInitialize = true;
      setTimeout(function () {
        if (_this2.props.index === _this2.props.slickItemActive) {
          _this2.videoPlayerRef.loadVideo();
        }
      }, 500);
    }
  }, {
    key: "handleEndVideo",
    value: function handleEndVideo() {
      this.props.handleNextSlider();
    }
  }, {
    key: "playVideo",
    value: function playVideo() {
      // this.comLabVideo.play();
      this.videoPlayerRef.launchPlay();
      this.props.handleCarouselChangeYear(this.props.strings.anio); //indica cual es el año activado
    }
  }, {
    key: "mute",
    value: function mute(boolean) {
      // this.comLabVideo.mute(boolean);
      if (!this.props.isApple && this.videoInitialize) {
        this.videoPlayerRef.launchMuted(boolean);
      }
    }
  }, {
    key: "visibleInSlider",
    value: function visibleInSlider() {
      if (this.props.index === this.props.slickItemActive) {
        // this.comLabVideo.play();
        if (this.videoInitialize) {
          this.videoPlayerRef.launchPlay();
        }
        this.anioActive();
      } else {
        this.noVisibleInSlider();
      }
    }
  }, {
    key: "noVisibleInSlider",
    value: function noVisibleInSlider() {
      var _this3 = this;

      // this.comLabVideo.pause();
      // this.comLabVideo.resetProgessVideo();

      if (this.videoInitialize) {
        setTimeout(function () {
          _this3.videoPlayerRef.launchPause();
          _this3.videoPlayerRef.launchResetProgress();
        }, 1000);
      }
    }
  }, {
    key: "anioActive",
    value: function anioActive() {
      if (!this.props.isApple && this.props.anioActive && this.props.anioActive === this.props.strings.anio && this.props.index === this.props.slickItemActive && this.props.mute === false) {
        //activamos sonido de este video
        this.mute(false);
      } else {
        this.mute(true);
      }
    }
  }, {
    key: "showModal",
    value: function showModal() {
      var _props = this.props,
          strings = _props.strings,
          handleModal = _props.handleModal;

      handleModal(strings);
    }
  }, {
    key: "maskVideo",
    value: function maskVideo(e) {
      e.preventDefault();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.visibleInSlider();
      if (!this.props.isApple) {
        this.mute(true);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this4 = this;

      //si cambia slickItemActive se actualiza
      if (prevProps.slickItemActive !== this.props.slickItemActive) {
        //si esta visible en el slider le damos a play
        this.visibleInSlider();
      }
      //si cambia anioActive se actualiza
      // if (prevProps.anioActive !== this.props.anioActive) {
      //   this.anioActive();
      // }
      this.anioActive();
      if (this.props.carouselScroll === 1) {
        setTimeout(function () {
          _this4.videoPlayerRef.launchPause();
          _this4.videoPlayerRef.launchResetProgress();
        }, 1000);
      }
      if (prevProps.carouselScroll !== this.props.carouselScroll && this.props.carouselScroll === 0) {
        // this.mute(false);
        this.visibleInSlider();
      }
      if (this.videoInitialize) {
        if (this.props.index === this.props.slickItemActive + 1) {
          this.mute(true);
          this.videoPlayerRef.loadVideo();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          strings = _props2.strings,
          anioActive = _props2.anioActive,
          handleNextSlider = _props2.handleNextSlider,
          handlePrevSlider = _props2.handlePrevSlider,
          id = _props2.id,
          index = _props2.index,
          slickItemActive = _props2.slickItemActive;


      var coverStyles = (0, _classnames2.default)({
        containerVideo__video__cover: true,
        hided: anioActive === strings.anio
      });

      var videoSrcHtml = strings.video.videoSrcMobile;
      if (!this.props.isMobile) {
        videoSrcHtml = strings.video.videoSrc;
      }

      return _react2.default.createElement(
        "div",
        { className: "containerVideo", ref: this.containerVideo },
        _react2.default.createElement(
          "h2",
          { className: "containerVideo__title" },
          strings.title
        ),
        _react2.default.createElement(
          "button",
          {
            className: "containerVideo__buttonMoreInfo",
            onClick: this.showModal
          },
          _react2.default.createElement("span", { className: "containerVideo__buttonMoreInfo__icon icon-more" })
        ),
        _react2.default.createElement(
          "div",
          { className: "containerVideo__video" },
          _react2.default.createElement(
            "button",
            { className: coverStyles, onClick: this.handleButtonPlay },
            _react2.default.createElement(
              "div",
              { className: "containerVideo__video__cover__buttonPlay" },
              _react2.default.createElement("span", { className: "containerVideo__video__cover__buttonPlay__icon icon-play" })
            )
          ),
          _react2.default.createElement("button", { className: "containerVideo__video__divPlay", onClick: function onClick(e) {
              return _this5.maskVideo(e);
            } }),
          _react2.default.createElement(
            "div",
            { className: "containerVideo__video__mask" },
            _react2.default.createElement(_components.VideoPlayer, {
              indexSlider: index,
              slickItemActive: slickItemActive,
              anioActive: anioActive,
              anioDelElemento: strings.anio,
              onRef: function onRef(ref) {
                return _this5.videoPlayerRef = ref;
              },
              idVideo: "videojs-vr-player-" + id,
              urlVideoDesktop: videoSrcHtml,
              urlVideoMobile: videoSrcHtml,
              videoType: "video/mp4",
              titleVideo: strings.video.titleVideo,
              programTitle: strings.video.titleProject,
              duration: strings.video.duration,
              handleReadyVideo: this.handleReadyVideo,
              handleEndVideo: this.handleEndVideo,
              poster: strings.video.poster
            })
          )
        ),
        _react2.default.createElement(
          "h3",
          { className: "containerVideo__subTitle" },
          strings.subTitle
        ),
        _react2.default.createElement("p", { className: "containerVideo__text", dangerouslySetInnerHTML: { __html: strings.text || "" } })
      );
    }
  }]);
  return ContainerVideo;
}(_react2.default.Component), _class2.contextTypes = {
  baseUrl: _propTypes2.default.string.isRequired
}, _temp)) || _class);
exports.default = ContainerVideo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ContainerVideo/ContainerVideo.jsx
// module id = 695
// module chunks = 0